import React from "react";
import styled, { css } from "styled-components";

export const labelStyles = css`
    ${props => props.theme.typography.body2};
    color: ${props => props.theme.palette.text.secondary};
    margin-bottom: ${props => props.theme.spacing(0.5)};
`;

const StyledLabel = styled.label<LabelProps>`
    ${props => props.disabled && css`
        color: ${props.theme.palette.text.disabled};
    `}

    ${labelStyles};

    align-items: baseline;
    display: flex;
    margin: 0 0 4px 0;
    padding: ${props => props.theme.spacing(0, 1)};
`;
const LabelOptional = styled.span`
    ${props => props.theme.typography.body3};
    margin: 0;
    margin-left: auto;
`;

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    disabled?: boolean;
    optional?: boolean;
}
export const Label = (props: LabelProps) => {
    return (
        <StyledLabel {...props}>
            {props.children}
            {props.optional && <LabelOptional>(optional)</LabelOptional>}
        </StyledLabel>
    )
};
